
(function(){
  var main=document.getElementById('mainphoto');
  document.querySelectorAll('#thumbs img').forEach(function(t){
    t.addEventListener('click',function(){
      main.src=t.src; main.alt=t.alt;
      document.querySelectorAll('#thumbs img').forEach(function(x){x.classList.remove('on')});
      t.classList.add('on');
    });
  });

  function fmt(n){return '$'+n.toLocaleString('en-US',{minimumFractionDigits:(n%1?2:0),maximumFractionDigits:2});}
  var labels=document.querySelectorAll('#ccb2 .rooms-cards label');
  var bp=document.getElementById('bp'),was=document.getElementById('was'),per=document.getElementById('peritem'),
      inst=document.getElementById('installment'),sp=document.getElementById('stickyprice');
  var current={vid:'37566833164458',price:98};
  function pick(l){
    labels.forEach(function(x){x.classList.remove('sel');x.querySelector('input').checked=false;});
    l.classList.add('sel'); l.querySelector('input').checked=true;
    var qty=+l.dataset.qty, price=+l.dataset.price, save=+l.dataset.save;
    current={vid:l.dataset.variantId,price:price};
    bp.textContent=fmt(price); inst.textContent=fmt(price/4); sp.textContent=fmt(price);
    if(qty>1){was.hidden=false; was.textContent=fmt(98*qty); per.textContent=fmt(price/qty)+' each · save '+save+'%';}
    else{was.hidden=true; per.textContent='';}
  }
  labels.forEach(function(l){l.addEventListener('click',function(){pick(l);});});

  function toCart(){fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+current.vid,quantity:1}]})}).then(function(){setTimeout(function(){window.location='/cart';},600);});}
  document.getElementById('atcMain').addEventListener('click',toCart);
  document.getElementById('shopPay').addEventListener('click',toCart);
  document.getElementById('stickyatc').addEventListener('click',toCart);
  document.getElementById('morePay').addEventListener('click',function(){window.location='/cart';});

  document.querySelectorAll('#ccb2 .jumpbuy').forEach(function(b){
    b.addEventListener('click',function(){document.getElementById('buy').scrollIntoView({behavior:'smooth'});});
  });

  document.querySelectorAll('#ccb2 .faq-item').forEach(function(item){
    var q=item.querySelector('.faq-q'), a=item.querySelector('.faq-a');
    q.addEventListener('click',function(){
      var open=item.classList.contains('open');
      document.querySelectorAll('#ccb2 .faq-item.open').forEach(function(o){o.classList.remove('open');o.querySelector('.faq-a').style.maxHeight=null;});
      if(!open){item.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
    });
  });

  var cards=document.getElementById('revcards');
  document.querySelector('#ccb2 .rev-arrow.prev').addEventListener('click',function(){cards.scrollBy({left:-cards.clientWidth,behavior:'smooth'});});
  document.querySelector('#ccb2 .rev-arrow.next').addEventListener('click',function(){cards.scrollBy({left:cards.clientWidth,behavior:'smooth'});});

  var sticky=document.getElementById('stickybar'), hero=document.querySelector('#ccb2 .hero');
  window.addEventListener('scroll',function(){
    var past=hero.getBoundingClientRect().bottom<0;
    sticky.classList.toggle('on',past);
  },{passive:true});

  // ── bundle builder (Lattice mechanics; automatic-discount duplicate variants) ──
  var CC_BRACELET_DUP='46450054922410';
  var btxt=document.getElementById('btxt'),btot=document.getElementById('btot'),bcta=document.getElementById('bcta');
  function bRecalc(){
    var sel=[].slice.call(document.querySelectorAll('#ccb2 .bitem.on'));
    var qtyLbl=document.querySelector('#ccb2 .rooms-cards label.sel');
    var base=qtyLbl?+qtyLbl.dataset.price:98;
    var is1=!qtyLbl||qtyLbl.dataset.qty==='1';
    var addons=sel.reduce(function(s,x){return s + +x.dataset.price;},0);
    var nAdd=sel.length;
    var count=nAdd+((is1&&nAdd)?1:0);
    var rate=count>=4?0.20:count>=2?0.10:0;
    var discBase=((is1&&nAdd)?base:0)+addons;
    var save=discBase*rate;
    if(nAdd){
      if(rate>0){
        var what=is1?'% off your whole bundle':'% off add-ons';
        btxt.innerHTML=count+' items: <b>'+(rate*100)+what+'</b> (save $'+save.toFixed(2)+'), applied automatically at checkout'+(count>=4?'':' · add '+(4-count)+' more for 20%');
      }else{
        btxt.innerHTML='1 add-on. Add 1 more and both are <b>10% off</b> at checkout';
      }
      btot.innerHTML=(save>0?'<s>$'+(base+addons).toFixed(2)+'</s>':'')+'$'+(base+addons-save).toFixed(2);
      bcta.textContent='Add Bracelet + '+nAdd+' to cart';
    }else{
      btxt.textContent='Select add-ons above. Bundle savings apply automatically at checkout.';
      btot.textContent='';
      bcta.textContent='Add Bracelet to cart';
    }
  }
  document.querySelectorAll('#ccb2 .bitem').forEach(function(b){
    b.addEventListener('click',function(){b.classList.toggle('on');bRecalc();});
  });
  labels.forEach(function(l){l.addEventListener('click',bRecalc);});
  bcta.addEventListener('click',function(){
    var addons=[].slice.call(document.querySelectorAll('#ccb2 .bitem.on')).map(function(b){return {id:+b.dataset.variantId,quantity:1};});
    var qtyLbl=document.querySelector('#ccb2 .rooms-cards label.sel');
    var is1=(!qtyLbl||qtyLbl.dataset.qty==='1')&&addons.length>0;
    var first={id:is1?+CC_BRACELET_DUP:+current.vid,quantity:1};
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[first].concat(addons)})})
      .then(function(){setTimeout(function(){window.location='/cart';},600);});
  });

  try{
    var avail=JSON.parse(document.getElementById('cc-variants').textContent);
    document.querySelectorAll('#ccb2 .rooms-cards label').forEach(function(l){
      if(avail[l.dataset.variantId]===false){
        l.style.opacity=.45; l.style.pointerEvents='none';
        var b=l.querySelector('.vr b'); if(b) b.textContent='Sold out';
      }
    });
  }catch(e){}
})();
